import * as React from 'react'

import NextButton from './next_button'
import PreviousButton from './previous_button'
import SlidePaginationButton from './slide_pagination_button'
import { INTRODUCTION, } from './constants'
import tourToSlides from './tour_to_slides'
import FreeMonthModal from './free_month_modal'
import AssetPreloader from './asset_preloader'

import { requestPost, } from '../../../../../../modules/request'

const DEFAULT_SLIDE = 0
const DEFAULT_TOUR = INTRODUCTION

const OnboardingTour = ({}) => {
  const [{ tour, slideIndex }, setTourState] = React.useState({
    tour: DEFAULT_TOUR,
    slideIndex: DEFAULT_SLIDE,
  })
  const [showFreeMonthModal, setShowFreeMonthModal] = React.useState(false)
  React.useEffect(() => {
    createUserMilestoneForBeginningOnboardingTour()
    preloadAssets()
  }, [])

  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [slideIndex])

  async function preloadAssets() {
    try {
      const preloader = new AssetPreloader()
      await preloader.preloadAssets()
    } catch (error) {
      // Silently handle preload errors - tour should still work
    }
  }

  function setTourAndResetSlideIndex(newTour) {
    setTourState({ tour: newTour, slideIndex: DEFAULT_SLIDE })
  }

  function createUserMilestoneForBeginningOnboardingTour() {
    requestPost(
      `${window.postbuildEnv.DEFAULT_URL}/milestones/complete_see_onboarding_slides_v1`,
      {},
      () => {}
    )
  }

  function getPremiumCredit() {
    requestPost(
      `${window.postbuildEnv.DEFAULT_URL}/milestones/complete_onboarding_tour`,
      {},
      () => {}
    )
    setShowFreeMonthModal(true)
  }

  function redirectToFinishSignUp() {
    window.location.href = '/finish_sign_up'
  }

  function goToLastSlideOfIntroduction() {
    setTourState({
      tour: INTRODUCTION,
      slideIndex: tourToSlides[INTRODUCTION]({ setTour: setTourAndResetSlideIndex }).length - 1,
    })
  }

  function goToPreviousSlide() {
    setTourState((prev) => ({ ...prev, slideIndex: prev.slideIndex - 1 }))
  }

  function goToNextSlide() {
    setTourState((prev) => ({ ...prev, slideIndex: prev.slideIndex + 1 }))
  }

  function setSlideIndex(slideIndex) {
    setTourState((prev) => ({ ...prev, slideIndex: slideIndex }))
  }

  const slides = tourToSlides[tour]({ setTour: setTourAndResetSlideIndex, getPremiumCredit, })

  const onFirstSlide = slideIndex === 0
  const onLastSlide = slideIndex === slides.length - 1

  return (
    <main className="onboarding-tour-container">
      {showFreeMonthModal && <FreeMonthModal closeModal={redirectToFinishSignUp} />}
      <div className="container">{slides[slideIndex]}</div>
      <nav aria-label="Pagination" className="pagination-section">
        <div className="container">
          <div className="previous-button-wrapper">
            <PreviousButton
              goToLastSlideOfIntroduction={goToLastSlideOfIntroduction}
              goToPreviousSlide={goToPreviousSlide}
              onFirstSlide={onFirstSlide}
              tour={tour}
            />
          </div>
          <ul>
            {slides.map((_, index) => <SlidePaginationButton index={index} key={`${tour}-${index}`} setSlideIndex={setSlideIndex} slideIndex={slideIndex} />)}
          </ul>
          <div className="next-button-wrapper">
            <NextButton
              goToNextSlide={goToNextSlide}
              onLastSlide={onLastSlide}
              setTour={setTourAndResetSlideIndex}
              tour={tour}
            />
          </div>
        </div>
      </nav>
    </main>
  )
}

export default OnboardingTour
